import { ApolloClient } from 'apollo-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import Schema from 'graphql/schema.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: Schema.data,
});

const cache = new InMemoryCache({ 
  dataIdFromObject: o => o.id,
  fragmentMatcher
});
const client = new ApolloClient({
  cache: cache,
  link: createHttpLink({ uri: '/graphql' }),
});

client.writeData({
  data: {
    alerts: [] 
  }
});


export default client;
